module.exports = __webpack_public_path__ + "static/media/Decisions_Step3_Image8.af86c88a.jpg";